import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  ctrl_acc_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.IntegerDatatypeInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_years: fromDatatype.IntegerDatatypeInterface;
  inserted_into_ctrl_acc: boolean;
  descr: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  ctrl_acc_posting_error: fromDatatype.VarcharDatatypeInterface;
  ctrl_acc_posting_status: fromDatatype.VarcharDatatypeInterface;
  balance_posting_error: fromDatatype.VarcharDatatypeInterface;
  balance_posting_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_account_txn_line_RowClass implements bl_aat_claim_account_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  ctrl_acc_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  topup_amount: fromDatatype.IntegerDatatypeInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_years: fromDatatype.IntegerDatatypeInterface;
  inserted_into_ctrl_acc: boolean;
  descr: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  ctrl_acc_posting_error: fromDatatype.VarcharDatatypeInterface;
  ctrl_acc_posting_status: fromDatatype.VarcharDatatypeInterface;
  balance_posting_error: fromDatatype.VarcharDatatypeInterface;
  balance_posting_status: fromDatatype.VarcharDatatypeInterface;
}
